// extracted by mini-css-extract-plugin
export var active = "_g9-7";
export var blink = "_g9-8";
export var dropDownSelector = "_g9-4";
export var dropDownWrapper = "_g9-3";
export var fakeCursor = "_g9-6";
export var fontSizeButton = "_g9-9";
export var formQuillEditor = "_g9-0";
export var pressed = "_g9-a";
export var qlBlank = "_g9-1";
export var textFormattingToolbar = "_g9-2";
export var textToolbarOption = "_g9-5";